export const formatPaymentType = (type) => {
	let formattedType = "";

    switch(type) {
        case 'balancePayment':
            formattedType = "BP";
            break;
        case 'downPayment':
            formattedType = "DP";
            break;
        case 'penaltyPayment':
            formattedType = "Penalty Final Offer";
            break;
        case 'commissionPayment':
            formattedType = "Commission";
            break;
        case 'refundPayment':
            formattedType = "Refund";
            break;
        case 'settlementPayment':
            formattedType = "Settlement Payment";
            break;
        default:
            formattedType = type;
    }

	return formattedType;
}

export const formatPaymentSubtype = (subtype) => {
	let formattedType = "";

    switch(subtype) {
        case 'principal':
            formattedType = "Principal";
            break;
        case 'miscelaneous':
            formattedType = "Misc.";
            break;
        case 'rental':
            formattedType = "Rental";
            break;
        case 'reservation':
            formattedType = "Reservation";
            break;
        case 'spot':
            formattedType = "Spot";
            break;
        case 'single':
            formattedType = "Single";
            break;
        case 'multiple':
            formattedType = "Multiple";
            break;
        default:
            formattedType = subtype;
    }

	return formattedType;
}

export const calculateTotalPaymentAmountClient = (clientObj) => {

    const {
        reservation_amount,
        generateSpotPayment,
        spotPaymentAmount,
        generateDownPayments,
        principalAmount,
        //miscelaneousAmount,
        //rentalAmount,
        generateBalancePayment,
        balanceAmount,
        selectedSubtype,
		totalBalancePaymentMonths
    } = clientObj;

    let totalPaymentAmount = 0;

    if (reservation_amount) {
        totalPaymentAmount += Number(reservation_amount)
    }

    if (generateSpotPayment) {
        totalPaymentAmount += Number(spotPaymentAmount)
    }

    if (generateDownPayments) {
        totalPaymentAmount += Number(principalAmount)
        // totalPaymentAmount += (Number(miscelaneousAmount) * Number(totalDownPaymentMonths))
        // totalPaymentAmount += (Number(rentalAmount) * Number(totalDownPaymentMonths))
    }

    if (generateBalancePayment) {
        if (selectedSubtype.value === "single") {
            totalPaymentAmount += Number(balanceAmount)

        } else if (selectedSubtype.value === "multiple") {
            totalPaymentAmount += (Number(balanceAmount) * Number(totalBalancePaymentMonths))
        }
    }

    return totalPaymentAmount;
}

export const calculateTotalPaymentAmountTransfer = (transferSaveObj) => {

    const {
        //transferFeeAmount,
        paidAmount,
        balanceAmount,
        totalDownPaymentMonths,
        principalAmount,
        miscelaneousAmount,
        rentalAmount
    } = transferSaveObj;

    let totalPaymentAmount = 0;

    /*if (transferFeeAmount) {
        totalPaymentAmount += Number(transferFeeAmount)
    }*/

    if (paidAmount) {
        totalPaymentAmount += Number(paidAmount)
    }

    if (balanceAmount) {
        totalPaymentAmount += Number(balanceAmount)
    }

    if (totalDownPaymentMonths) {
        if (principalAmount) {
            totalPaymentAmount += (Number(principalAmount) * Number(totalDownPaymentMonths))
        }
        if (miscelaneousAmount) {
            totalPaymentAmount += (Number(miscelaneousAmount) * Number(totalDownPaymentMonths))
        }
        if (rentalAmount) {
            totalPaymentAmount += (Number(rentalAmount) * Number(totalDownPaymentMonths))
        }
    }

    return totalPaymentAmount;

}